import type { App } from 'vue';
import Connectors from './connectors';
import Interceptors from './interceptors';
import { createRequest } from './requests';

let api: ReturnType<typeof createRequest>;

export function useApi() {
  if (!api) {
    throw new Error('Api not initialized');
  }

  return api;
}

export default {
  install(Vue: App<Element>, config: any) {
    const { affiliatesApi, miscApi } = Connectors;

    const affiliatesApiInstance = affiliatesApi(config.affiliatesBaseUrl);
    const miscApiInstance = miscApi(config.miscBaseUrl);

    affiliatesApiInstance.interceptors.request
      .use(Interceptors.requestSuccessInterceptor, Interceptors.requestErrorInterceptor);
    miscApiInstance.interceptors.request
      .use(Interceptors.requestSuccessInterceptor, Interceptors.requestErrorInterceptor);

    affiliatesApiInstance.interceptors.response
      .use(Interceptors.responseSuccessInterceptor, Interceptors.responseErrorInterceptor);
    miscApiInstance.interceptors.response
      .use(Interceptors.responseSuccessInterceptor, Interceptors.responseErrorInterceptor);

    Vue.config.globalProperties.$api = createRequest(affiliatesApiInstance, miscApiInstance);
    api = Vue.config.globalProperties.$api;
    
    // if (!Vue.prototype.$api) {
    //   Object.defineProperty(Vue.prototype, '$api', {
    //     value: new Requests(affiliatesApiInstance, miscApiInstance),
    //     writable: false,
    //   });
    // }

    if (!config.store.$api) {
      Object.defineProperty(config.store, '$api', {
        value: Vue.config.globalProperties.$api,
        writable: false,
      });
    }
  },
};
